/**
 * Created by Thomas Mark
 * Date: 2021-04-07
 * 
 * Produktename ändern.
 * 
 */
import React from 'react';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import FormControl from '@material-ui/core/FormControl';
import Typography from '@material-ui/core/Typography';

import { ModalTitle } from "../../partials/ModalTitle";

import * as utils from "../../../basics/utils";
import * as appActions from "../../../store/actions/appActions";
import * as dirActions from "../../../store/actions/dirActions";
import * as portfolioActions from '../../../store/actions/portfolioActions';

const styles = (theme) => ({
    form: {
        '& .MuiTextField-root': {
            margin: theme.spacing(1),

        },
        display: 'flex',
        flexDirection: 'column',
        margin: 'auto',
        width: 'fit-content',
    },
    formControl: {
        marginTop: theme.spacing(1),
        minWidth: 400
    },
})
class ProductModal extends React.Component {
    constructor(props) {
        super(props);

        this.component = 'ProductModal';

        this.debug = false;

        this.initProduct = {
            name: ''
        }

        this.state = {
            newProduct: this.initProduct,
            oldProduct: this.initProduct,
            validationError: false,
            validationMessage: "",
        }
    }

    // ==========================================================================
    //
    // HELPER - SECTION
    //
    // ==========================================================================

    validateWidget = (id, value) => {
        this.debug && console.log(`validateWidget(${id}, ${value})`);

        let newState = { validationError: false, validationMessage: '' };

        // Feld 'name' prüfen
        if (id === 'name') {
            if (/[^-&öüäÖÜÄß\w+( +\w+)*$]/.test(value)) {
                newState = { validationError: true, validationMessage: 'Wert ist ungültig!' };
            }
        }

        // Prüfen, ob Feld leer ist
        if (value === '') {
            newState = { validationError: true, validationMessage: 'Feld darf nicht leer sein!' };
        }

        this.debug && console.log(newState);

        this.setState(newState);
    }

    // ==========================================================================
    //
    // LIFESYCLE - SECTION
    //
    // ==========================================================================

    componentDidUpdate(prevProps) {
        const { modalDialog } = this.props.app;
        const { currentProduct } = this.props.portfolio;

        if (modalDialog.dialog === this.component && modalDialog.dialog !== prevProps.app.modalDialog.dialog) {

            if (modalDialog.type === 'create') {
                this.setState({ newProduct: this.initProduct, validationError: false, validationMessage: '' })
            } else {
                this.setState({ newProduct: currentProduct, oldProduct: currentProduct, validationError: false, validationMessage: '' })
            }
        }
    }

    // ==========================================================================
    //
    // RENDER - SECTION
    //
    // ==========================================================================
    render() {
        const { modalDialog, path } = this.props.app;
        const { newProduct, validationError, validationMessage } = this.state;

        const { classes } = this.props;
        const { currentProduct } = this.props.portfolio;

        const dialog = utils.getDialogByPath(path);

        const exitModal = () => {
            this.props.scanPortfolio(dialog.portfolio, null, null, dialog.portfolio + '/' + dialog.groups + '/' + newProduct.name);
            this.props.setModalDialog(null, null)
        }

        const onError = (error) => {
            const newState = { validationError: true, validationMessage: error.response.data.message };

            this.debug && console.log(newState);

            this.setState(newState);
        }

        const onCreateProduct = () => {

            const onCreateSuccess = (data) => {
                this.props.scanPortfolio(dialog.portfolio, null, null, dialog.portfolio + '/' + dialog.groups);
                this.props.setModalDialog(null, null)
            }

            this.props.createDir(path + '/' + newProduct.name, onCreateSuccess, onError);
        }

        const onUpdateProduct = () => {
            const onRenameSuccess = (data) => {
                currentProduct.name = newProduct.name;
                exitModal();
            }

            if (currentProduct.name !== newProduct.name) {
                this.props.renameDir(path, newProduct.name, onRenameSuccess, onError);
            } else {
                exitModal();
            }
        }

        const onDeleteProduct = () => {
            const onDeleteSuccess = (data) => {
                this.props.scanPortfolio(dialog.portfolio, null, null, dialog.portfolio + '/' + dialog.groups);
                this.props.setModalDialog(null, null)
            }

            this.props.deleteDir(path, onDeleteSuccess, onError);
        }

        const onSave = () => {
            if (modalDialog.type === 'create') { onCreateProduct() }
            if (modalDialog.type === 'update') { onUpdateProduct() }
            if (modalDialog.type === 'delete') { onDeleteProduct() }
        }

        const onCancel = () => {
            this.props.setModalDialog(null, null)
        }

        const onChange = (e) => {
            this.validateWidget(e.target.id, e.target.value);

            this.setState({ newProduct: { ...newProduct, [e.target.id]: e.target.value } });
        }

        const onSubmit = (e) => {
            e.preventDefault();
        }

        // ==========================================================================
        // 
        // MAIN RENDER
        // 
        // ==========================================================================
        if (modalDialog.dialog !== this.component) return null;

        let dialogTitle = '';
        if (modalDialog.type === 'create') dialogTitle = 'Produkt erstellen';
        if (modalDialog.type === 'update') dialogTitle = 'Produkt ändern';
        if (modalDialog.type === 'delete') dialogTitle = 'Produkt löschen';

        const disabled = modalDialog.type === 'delete';

        return (
            <div>
                <Dialog open={true} maxWidth={'md'} >
                    <ModalTitle onClose={onCancel}>{dialogTitle}</ModalTitle>
                    <DialogContent>
                        <form className={classes.form} noValidate onSubmit={onSubmit}>
                            <FormControl className={classes.formControl}>
                                <TextField
                                    autoFocus
                                    id="name"
                                    autoComplete="off"
                                    label="Titel"
                                    type="text"
                                    fullWidth={true}
                                    disabled={disabled}
                                    value={newProduct.name}
                                    onChange={onChange}
                                    InputLabelProps={{ shrink: true }}
                                    margin="normal"
                                />
                            </FormControl>
                        </form>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={onCancel} variant="outlined" color="default">Abbruch</Button>
                        <Button onClick={onSave} variant="contained" color="primary" disabled={validationError}>OK</Button>
                    </DialogActions>
                    <Typography className="w-full px-8" variant="h6" noWrap>
                        {validationMessage === '' ? <span>&nbsp;</span> : validationMessage}
                    </Typography>
                </Dialog>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        app: state.app,
        dir: state.dir,
        portfolio: state.portfolio,
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(Object.assign({}, appActions, dirActions, portfolioActions), dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ProductModal));